import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Icon,
  Input,
  InputNumber,
  Modal,
  notification,
  Popconfirm,
  Radio,
  Row,
  Select,
  Switch,
  Tabs,
  Tooltip
} from 'antd';
import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router-dom';
import { deletePricingModel, getAllPricingModel, getPricingModel, postPricingModel, updatePricingModel } from 'utils/apis/configPricingModel';
import { getAllProduct } from 'utils/apis/configProduct';
import { getAllTax } from 'utils/apis/configTax';
import { getConstants } from 'utils/apis/constants';
import { getHostsForBilling } from 'utils/apis/host';
import { currencyLists, defaultPricingModel, MONTHS, billingFunctions, HOST_CONNECT_OTA_OPTIONS } from 'utils/constants';
import { buildAPBillingConfigPricingModelURI } from 'utils/routes';
import PricingTableModal from '../../PricingTable/PricingTableModal/PricingTableModal';
import { ItemsProvided } from 'components/DynamicFieldSet/ItemsProvided';
import SubscriptionAddOnPricingTable from '../components/subscriptionAddOnPricingTable/subscriptionAddOnPricingTable';
const { Option, OptGroup } = Select;

const PricingModelForm = ({ form, match, history }) => {
  const { id } = match.params; // Extract ID from URL
  //Pricing Model
  const [countryOptions, setCountryOptions] = useState([]);
  const [taxOptions, setTaxOptions] = useState([]);
  const [pricingModelOptions, setPricingModelOptions] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingData, setLoadingData] = useState(false); // Loading state for data fetching
  const [assignedHosts, setAssignedHosts] = useState([]);
  const [unassignedHosts, setUnassignedHosts] = useState([]);
  const [assignedHostsFromOtherPricingModel, setAssignedHostsFromOtherPricingModel] = useState([]);
  const [allUnassignedHosts, setAllUnassignedHosts] = useState([]);
  const [allHostsAssigned, setAllHostsAssigned] = useState(false);
  const [allHostsUnassigned, setAllHostsUnassigned] = useState(false);

  //otherProducts
  const [productFields, setProductFields] = useState([]);
  const [counter, setCounter] = useState(0);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [currentSubscriptionProducts, setCurrentSubscriptionProducts] = useState([]);

  //Pricing Table
  const [selectedPricingTable, setSelectedPricingTable] = useState(null);
  const [selectedSubscriptionAddOnProductsTable, setSelectedSubscriptionAddOnProductsTable] = useState([]);
  const [productData, setProductData] = useState([]);
  const [isChecked, setIsChecked] = useState(true);

  // Delete Confirmation Modal
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  // Subscription Add-On Host Type Selection (true = Existing Hosts, false = New Hosts)
  const [existingHostOption, setExistingHostOption] = useState(true);

  // Charged by functions only toggle
  const [chargedByFunctionsOnly, setChargedByFunctionsOnly] = useState(false);

  // Only bill Unified Inbox for units with selected OTA hostConnect active
  const [onlyBillUnifiedInboxOTAUnits, setOnlyBillUnifiedInboxOTAUnits] = useState(false);
  const [unifiedInboxOtaKeys, setUnifiedInboxOtaKeys] = useState([]);

  //Max Unit Constant

  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  // Right now, countries are pulling from backend, do I need to use country-state-city library ? and why ?
  useEffect(() => {
    const fetchData = async () => {
      setLoadingData(true);
      try {
        // Fetch the pricing model first if an id is present
        if (id) {
          await fetchPricingModel(id);
        }

        // Then fetch the rest of the data
        await Promise.all([fetchCountries(), fetchAllHost(), fetchAllTax(), fetchAllProducts(), fetchAllPricingModel()]);
      } catch (error) {
        console.error('Error fetching initial data:', error);
      } finally {
        setLoadingData(false);
      }
    };

    fetchData();
  }, [id]);

  const fetchPricingModel = async id => {
    try {
      const { data } = await getPricingModel(id);
      setFieldsValue({
        name: data.name,
        country: data.country,
        currency: data.currency,
        host: data.host,
        pricingTable: data.pricingTable,
        taxes: data.taxes,
        hostProtect: data.hostProtect,
        chargeableChild: data.chargeableChild,
        subscriptionType: data.subscriptionType
      });

      const productFieldsData = data.otherProducts.map((product, index) => {
        return index;
      });
      setProductFields(productFieldsData);
      setSelectedPricingTable(data.pricingTable);
      setCounter(data.otherProducts.length);
      setIsChecked(data.chargeableChild);

      setSelectedProducts(
        data.otherProducts.map((p, index) => ({
          key: p.product,
          label: p.name,
          fieldIndex: index
        }))
      );

      data.otherProducts.forEach((product, index) => {
        setFieldsValue({
          [`otherProducts[${index}]`]: { key: product.product, label: product.name, parent: product.parent },
          [`price[${index}]`]: product.price
        });
      });

      // Initialize subscription add-on pricing table data if exists
      if (data.subscriptionAddOnPricingTable && data.subscriptionAddOnPricingTable.length > 0) {
        setSelectedSubscriptionAddOnProductsTable(data.subscriptionAddOnPricingTable);
      }

      // Set existing host option if exists
      if (data.existingHostOption !== undefined) {
        setExistingHostOption(data.existingHostOption);
      }

      // Set charged by functions only if exists
      if (data.chargedByFunctionsOnly !== undefined) {
        setChargedByFunctionsOnly(data.chargedByFunctionsOnly);
      }

      if (data.onlyBillUnifiedInboxOTAUnits !== undefined) {
        setOnlyBillUnifiedInboxOTAUnits(data.onlyBillUnifiedInboxOTAUnits);
      }

      if (data.unifiedInboxOtaKeys && Array.isArray(data.unifiedInboxOtaKeys)) {
        setUnifiedInboxOtaKeys(data.unifiedInboxOtaKeys);
      }
    } catch (error) {
      console.error('Error fetching Existing Pricing Model data:', error);
    }
  };

  const fetchAllPricingModel = async () => {
    try {
      const res = await getAllPricingModel();
      setPricingModelOptions(res.data);
    } catch (error) {
      console.error('Error fetching all pricing model data:', error);
    }
  };

  const fetchCountries = () => {
    getConstants('countries').then(countriesRes => {
      if (countriesRes && countriesRes.status === 200) {
        const options = Object.keys(countriesRes.data).map(k => ({
          key: countriesRes.data[k].iso2,
          label: countriesRes.data[k].name,
          value: countriesRes.data[k].name
        }));
        setCountryOptions([
          {
            key: 'global',
            label: 'Global',
            value: 'Global'
          },
          ...options
        ]);
      }
    });
  };

  const fetchAllTax = async () => {
    try {
      const response = await getAllTax();
      setTaxOptions(response.data); // Update tax data state with fetched data
    } catch (error) {
      console.error('Error fetching tax data:', error);
    }
  };

  const fetchAllHost = async () => {
    try {
      const response = await getHostsForBilling();
      const allHosts = response.data;
      const selectedHosts = form.getFieldValue('host') || [];

      //filter by matching host with current pricingmodel
      // what if its new, loop through each pricingModel to get the assignedModel ba

      let hostFromOtherPricingModel;
      if (id) {
        // Filter out hosts assigned to other pricing models
        hostFromOtherPricingModel = allHosts.filter(host => host.pricingModel && host.pricingModel !== id);
      } else {
        // Filter out hosts assigned to any pricing model
        hostFromOtherPricingModel = allHosts.filter(host => host.pricingModel);
      }

      setAssignedHostsFromOtherPricingModel(hostFromOtherPricingModel);

      //All Host - HostFromOtherPricingModel = allUnassignedHosts
      const allUnassignedHosts = allHosts.filter(host => !hostFromOtherPricingModel.some(otherHost => otherHost._id === host._id));
      setAllUnassignedHosts(allUnassignedHosts);

      setAssignedHosts(allUnassignedHosts.filter(host => selectedHosts.includes(host._id)));
      setUnassignedHosts(allUnassignedHosts.filter(host => !selectedHosts.includes(host._id)));

      let localAssignedHosts = allUnassignedHosts.filter(host => selectedHosts.includes(host._id));
      const monthFields = {};
      localAssignedHosts.forEach((host, index) => {
        monthFields[`month[${host._id}]`] = host.subscriptionMonth;
      });
      setFieldsValue(monthFields);
    } catch (error) {
      console.error('Error fetching host data:', error);
    }
  };

  const fetchAllProducts = async () => {
    try {
      const response = await getAllProduct();
      setProductData(response.data); // Update tax data state with fetched data
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  };

  const massageDataAsPayload = values => {
    //console.log(values);
    const pricingCriteria = {};

    // Prepare pricingCriteria tiers
    values.header.forEach((header, index) => {
      pricingCriteria[`tier${index + 1}`] = {
        minUnit: header.minUnit,
        maxUnit: header.maxUnit === undefined || header.maxUnit === null ? null : header.maxUnit
      };
    });

    // Prepare products array
    const products = values.product
      .map((product, columnIndex) => {
        const tiers = {};
        values.header.forEach((header, index) => {
          const monthPrice = values.monthPrice && values.monthPrice[columnIndex] && values.monthPrice[columnIndex][index];
          const yearPrice = values.yearPrice && values.yearPrice[columnIndex] && values.yearPrice[columnIndex][index];

          // Skip this tier if both prices are empty/null.
          if (monthPrice == null && yearPrice == null) return;

          tiers[`tier${index + 1}`] = {
            ...(monthPrice != null && { monthPrice }),
            ...(yearPrice != null && { yearPrice })
          };
        });

        if (!(product && product[0] && product[0].key) || Object.keys(tiers).length === 0) {
          return null;
        }

        return {
          product: product[0].key,
          tiers
        };
      })
      .filter(Boolean);

    console.log(products, 'products');

    const payload = {
      name: values.pricingTableName,
      pricingCriteria,
      products
    };

    return payload;
  };

  // Transform subscription add-on pricing table form values into payload
  // Each object = 1 subscription add-on product
  // Each object has subscriptionAddOnProduct and array of subscriptionProducts with listingPrice
  const messageSubscriptionAddOnPricingTableDataAsPayload = (values, currentSubscriptionProducts) => {
    const subscriptionAddOnPricingTable = [];

    // Get the sub-add-on products from form values
    const subAddOnProducts = values['sub-add-on-product'] || [];
    const listingPrices = values.listingPrice || [];

    // Iterate through each row (each subscription add-on product)
    subAddOnProducts.forEach((productRow, rowIndex) => {
      // productRow is an array where index 0 contains the selected product (labelInValue format)
      const selectedProduct = productRow && productRow[0];

      if (selectedProduct && selectedProduct.key) {
        const subscriptionProducts = [];

        // Iterate through each column (each subscription package)
        currentSubscriptionProducts.forEach((subscriptionProduct, colIndex) => {
          if (subscriptionProduct && subscriptionProduct.key) {
            // Get the listing price for this row and column
            const priceValue = listingPrices[rowIndex] && listingPrices[rowIndex][colIndex];
            const listingPrice = parseFloat(priceValue);

            if (listingPrice === undefined || Number.isNaN(listingPrice)) return;
            subscriptionProducts.push({
              subscriptionProduct: subscriptionProduct.key,
              listingPrice
            });
          }
        });

        subscriptionAddOnPricingTable.push({
          subscriptionAddOnProduct: selectedProduct.key,
          subscriptionProducts
        });
      }
    });

    return subscriptionAddOnPricingTable;
  };

  const handleProductsChange = products => {
    setCurrentSubscriptionProducts(products);
  };

  const handleSubmit = e => {
    e.preventDefault();

    form.validateFieldsAndScroll(async (errors, values) => {
      console.log(values, 231);

      if (!errors) {
        if (onlyBillUnifiedInboxOTAUnits && unifiedInboxOtaKeys.length === 0) {
          notification.error({
            message: 'Validation error',
            description: 'Select at least one OTA for Unified Inbox billing.'
          });
          return;
        }

        const pricingTablePayload = massageDataAsPayload(values);

        // show new field called subscrriptionAddOnPricingTable, each object = 1 subscription add on product
        // then each object would have subscriptionAddOnProduct, and array called subscriptionProduct, with each would have lsiting price inside,
        const subscrriptionAddOnPricingTablePayload = messageSubscriptionAddOnPricingTableDataAsPayload(values, currentSubscriptionProducts);

        const otherProducts = values.otherProducts
          ? values.otherProducts
              .map((product, index) => ({
                product: product.key, // Assuming the product is selected using labelInValue
                price: values.price[index],
                name: product.label
              }))
              .filter(({ product, price, name }) => product && price != null && name) // Filter out entries with empty values
          : [];

        let pricingModelPayload = {
          country: values.country,
          currency: values.currency,
          host: values.host,
          hostProtect: values.hostProtect,
          name: values.name,
          otherCharges: values.otherCharges,
          taxes: values.taxes,
          pricingTable: pricingTablePayload,
          otherProducts: otherProducts, // Add the otherProducts field
          chargeableChild: isChecked,
          subscriptionType: values.subscriptionType,
          month: values.month,
          subscriptionAddOnPricingTable: subscrriptionAddOnPricingTablePayload,
          existingHostOption: existingHostOption,
          chargedByFunctionsOnly: chargedByFunctionsOnly,
          onlyBillUnifiedInboxOTAUnits: onlyBillUnifiedInboxOTAUnits,
          unifiedInboxOtaKeys: onlyBillUnifiedInboxOTAUnits ? unifiedInboxOtaKeys : []
        };
        try {
          setLoadingSubmit(true);
          if (id) {
            await updatePricingModel(id, pricingModelPayload);
            notification.success({
              message: 'Success',
              description: 'Pricing Model has been updated successfully.'
            });
          } else {
            await postPricingModel(pricingModelPayload);
            notification.success({
              message: 'Success',
              description: 'Pricing Model has been created successfully.'
            });
            setLoadingSubmit(false);
            history.push(`${buildAPBillingConfigPricingModelURI()}`);
          }
          setLoadingSubmit(false);
        } catch (error) {
          console.error('Error submitting Pricing Table:', error);
        }
      } else {
        const errorMessages = Object.keys(errors)
          .map(key => {
            console.log(key);
            console.log(errors[key]);
            return errors[key] && Array.isArray(errors[key])
              ? errors[key]
                  .map(errorObj => (errorObj.errors && Array.isArray(errorObj.errors) ? errorObj.errors.map(err => err.message).join(', ') : ''))
                  .filter(message => message)
                  .join(', ')
              : '';
          })
          .filter(message => message)
          .join(', ');

        notification.error({
          message: 'Validation Error',
          description: errorMessages
        });
      }
    });
  };

  const handleSelectAllHosts = () => {
    setFieldsValue({
      host: allUnassignedHosts.map(host => host._id)
    });
    setAssignedHosts(allUnassignedHosts);
    setUnassignedHosts([]);
    setAllHostsAssigned(true);
    setAllHostsUnassigned(false);
  };

  const handleDeselectAllHosts = () => {
    setFieldsValue({
      host: []
    });
    setAssignedHosts([]);
    setUnassignedHosts(allUnassignedHosts);
    setAllHostsAssigned(false);
    setAllHostsUnassigned(true);
  };

  const handleDelete = () => {
    setDeleteModalVisible(true);
  };

  const confirmDelete = async () => {
    try {
      await deletePricingModel(id);
      notification.success({
        message: 'Success',
        description: 'Pricing Model has been deleted successfully.'
      });
      history.push(`${buildAPBillingConfigPricingModelURI()}`);
    } catch (error) {
      console.error('Error deleting Pricing Model:', error);
    } finally {
      setDeleteModalVisible(false);
    }
  };

  const cancelDelete = () => {
    setDeleteModalVisible(false);
  };

  const addProduct = () => {
    setProductFields([...productFields, counter]);
    setCounter(counter + 1);
  };

  const handleCheckboxChange = e => {
    setIsChecked(e.target.checked);
  };

  const handleRemoveProductField = index => {
    console.log(index, 70);
    const updatedProductFields = productFields.filter((_, idx) => _ !== index);
    console.log(updatedProductFields);
    setProductFields(updatedProductFields);

    //Restore back product in selection
    setSelectedProducts(prevSelected => prevSelected.filter(item => item.fieldIndex !== index));

    const updatedValues = { ...form.getFieldsValue() };
    delete updatedValues[`otherProducts[${index}]`];
    delete updatedValues[`price[${index}]`];
    setFieldsValue(updatedValues);
  };

  const handleProductSelection = (value, productIndex) => {
    //keep track of index and also value
    form.setFieldsValue({
      [`otherProducts[${productIndex}`]: value
    });

    setSelectedProducts(prevSelected => {
      // Remove the previously selected product for this index, if any
      //if productIndex matches then discard the array in that specific index, to make way for new value
      const filteredSelected = prevSelected.filter(item => item.fieldIndex !== productIndex);

      // Add the new selection with its field index
      if (value) {
        return [...filteredSelected, { ...value, fieldIndex: productIndex }];
      }

      return filteredSelected;
    });
  };

  const renderProductFields = () =>
    productFields.map(fieldIndex => {
      /* const fieldValue = getFieldValue(`otherProducts[${fieldIndex}]`);
      let addonAfter = null;

      if (fieldValue && fieldValue.parent) {
        const parent = parentProductCategory.find(productCategory => productCategory.value === fieldValue.parent);
        addonAfter = parent.addOnAfter;
      } */

      return (
        <Row gutter={16} style={{ paddingTop: '12px' }} key={fieldIndex}>
          <Col span={12}>
            <Form.Item style={{ width: '100%', textAlign: 'center', marginBottom: '0px' }}>
              {getFieldDecorator(`otherProducts[${fieldIndex}]`, {
                rules: [{ required: true, message: 'Please select a product' }]
              })(
                <Select
                  placeholder="Select a product"
                  style={{ width: '100%' }}
                  onChange={value => handleProductSelection(value, fieldIndex)}
                  labelInValue
                >
                  {productData
                    .filter(
                      product =>
                        !selectedProducts.some(sp => sp.key === product._id && sp.fieldIndex !== fieldIndex) &&
                        !product.categoryParent.includes('system')
                    )
                    .map(product => (
                      <Select.Option key={product._id} value={product._id}>
                        {product.name}
                      </Select.Option>
                    ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item>
              {getFieldDecorator(`price[${fieldIndex}]`, {
                rules: [
                  { required: true, message: 'Please Input Price' },
                  { pattern: /^(?:\d*\.\d{1,2}|\d+)$/, message: 'Please enter a valid price with up to 2 decimal places' }
                ]
              })(
                <InputNumber
                  placeholder="0.00"
                  style={{ width: '100%' }}
                  min={0}
                  step={0.01}
                  precision={2}
                  formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={value => value.replace(/\$\s?|(,*)/g, '')}
                  //addonAfter={addonAfter}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={1}>
            <Popconfirm
              title="Are you sure you want to remove this product?"
              onConfirm={() => handleRemoveProductField(fieldIndex)}
              okText="Yes"
              cancelText="No"
            >
              <Button className="booking-form-danger" shape="circle" type="danger">
                <Icon type="minus" />
              </Button>
            </Popconfirm>
          </Col>
        </Row>
      );
    });

  return (
    <>
      <Card title="Pricing Model Form" style={{ width: '100%', margin: '30px' }}>
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Model Name">
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: 'Please enter the model name' }]
                })(<Input placeholder="Enter Model Name" disabled={loadingData} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Subscription Type">
                {getFieldDecorator('subscriptionType', {
                  rules: [{ required: true, message: 'Please select the subscription type' }],
                  initialValue: 'monthly'
                })(
                  <Select placeholder="Select Subscription Type" disabled={loadingData}>
                    <Select.Option value="monthly">Monthly</Select.Option>
                    <Select.Option value="yearly">Yearly</Select.Option>
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Country">
                {getFieldDecorator('country', {
                  rules: [{ required: true, message: 'Please select the country' }]
                })(
                  <Select showSearch optionFilterProp="children" placeholder="Select Country" disabled={loadingData}>
                    {countryOptions.map(country => (
                      <Option key={country.key} value={country.key}>
                        {country.label}
                      </Option>
                    ))}
                  </Select>
                )}
                {getFieldValue('country') === 'global' && (
                  <Alert message="This pricing model is applicable to all countries!" type="warning" showIcon style={{ marginTop: '8px' }} />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Currency">
                {getFieldDecorator('currency', {
                  rules: [{ required: true, message: 'Please select Currency' }],
                  initialValue: 'MYR'
                })(
                  <Select showSearch optionFilterProp="children" placeholder="Select Country" disabled={loadingData}>
                    {currencyLists.map(currencyList => (
                      <Option key={currencyList.cc} value={currencyList.cc}>
                        {currencyList.name} ({currencyList.cc})
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Host">
            {getFieldDecorator('host', {
              onChange: value => {
                const newAssignedHosts = allUnassignedHosts.filter(host => value.includes(host._id));
                const newUnassignedHosts = allUnassignedHosts.filter(host => !value.includes(host._id));
                const monthFields = {};
                newAssignedHosts.forEach((host, index) => {
                  monthFields[`month[${host._id}]`] = host.subscriptionMonth;
                });
                setFieldsValue(monthFields);
                setAssignedHosts(newAssignedHosts);
                setUnassignedHosts(newUnassignedHosts);
                setAllHostsAssigned(newUnassignedHosts.length === 0);
                setAllHostsUnassigned(newAssignedHosts.length === 0);
              }
            })(
              <Select
                mode="multiple"
                placeholder="Select Host"
                disabled={loadingData}
                maxTagCount={100}
                //
                filterOption={(userInput, option) => {
                  var regex = new RegExp(userInput, 'im');
                  return regex.test(option.props.children);
                }}
              >
                <OptGroup label="Unassigned Hosts">
                  {unassignedHosts.map(host => (
                    <Option key={host._id} value={host._id}>
                      {host.name}
                    </Option>
                  ))}
                </OptGroup>
                <OptGroup label="Assigned Hosts">
                  {assignedHosts.map(host => (
                    <Option key={host._id} value={host._id}>
                      {host.name}
                    </Option>
                  ))}
                </OptGroup>
                <OptGroup label="Assigned to Other Pricing Models">
                  {assignedHostsFromOtherPricingModel.map(host => {
                    const pricingModel = pricingModelOptions.find(model => model._id === host.pricingModel);
                    return (
                      <Option key={host._id} value={host._id} disabled>
                        {host.name} - {pricingModel ? pricingModel.name : 'Unknown Pricing Model'}
                      </Option>
                    );
                  })}
                </OptGroup>
              </Select>
            )}
            <Row justify="end" type="flex" gutter={4} style={{ marginTop: '8px' }}>
              <Col>
                <Button
                  onClick={handleSelectAllHosts}
                  id={'select-all-button'}
                  ghost
                  type="primary"
                  style={{
                    marginRight: '8px'
                  }}
                  disabled={loadingData || allHostsAssigned}
                >
                  Select All
                </Button>
              </Col>
              <Col>
                <Button onClick={handleDeselectAllHosts} disabled={loadingData || allHostsUnassigned} id={'clear-all-button'} ghost type="primary">
                  Clear All
                </Button>
              </Col>
            </Row>
            {getFieldValue('subscriptionType') === 'yearly' && assignedHosts.length > 0 && (
              <>
                <Alert
                  message="Please remember to key in the Yearly Renewal Month for each host."
                  type="warning"
                  showIcon
                  style={{ width: '900px', marginTop: '12px' }}
                />
                <div style={{ display: 'flex', justifyContent: 'left' }}>
                  <div
                    style={{
                      marginTop: '8px',
                      border: '1px solid #d9d9d9',
                      borderRadius: '4px',
                      display: 'inline-flex',
                      flexDirection: 'column',
                      width: 'auto',
                      overflow: 'hidden' // This ensures the border-radius is applied correctly
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        borderBottom: '1px solid #d9d9d9',
                        backgroundColor: '#fafafa'
                      }}
                    >
                      <div style={{ width: '600px', fontWeight: 'bold', padding: '8px', borderRight: '1px solid #d9d9d9' }}>Host Name</div>
                      <div style={{ width: '300px', fontWeight: 'bold', padding: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        Billing Month
                        <Tooltip title="Invoice would be refreshed every billing month.">
                          <QuestionCircleOutlined style={{ cursor: 'pointer' }} />
                        </Tooltip>
                      </div>{' '}
                    </div>
                    {assignedHosts.map((host, index) => (
                      <div
                        key={host._id}
                        style={{
                          display: 'flex',
                          borderBottom: index < assignedHosts.length - 1 ? '1px solid #d9d9d9' : 'none'
                        }}
                      >
                        <div style={{ width: '600px', padding: '8px', borderRight: '1px solid #d9d9d9' }}>{host.name}</div>
                        <div style={{ width: '300px', padding: '8px' }}>
                          <Form.Item>
                            {getFieldDecorator(`month[${host._id}]`, {
                              rules: [{ required: true, message: 'Please select a month' }]
                            })(
                              <Select placeholder="Select Month" style={{ width: '100%' }}>
                                {MONTHS.map(month => (
                                  <Option key={month.code} value={month.code}>
                                    {month.label}
                                  </Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <Divider style={{ marginBottom: '0' }} />
              </>
            )}
          </Form.Item>
          <Form.Item label="Tax Implementation">
            {getFieldDecorator('taxes')(
              <Select mode="multiple" placeholder="Select Tax" disabled={loadingData} optionLabelProp="label">
                {taxOptions.map(tax => (
                  <Option key={tax._id} value={tax._id} label={tax.name}>
                    <Row gutter={16}>
                      <Col span={20}>{tax.name}</Col>
                      <Col span={4}>{tax.type === 'percentage' ? `${tax.amount}%` : `Fixed Amount of ${tax.amount}`}</Col>
                    </Row>
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>

          <Row style={{ marginTop: '16px', marginBottom: '16px' }}>
            <Col>
              <Switch checked={chargedByFunctionsOnly} onChange={checked => setChargedByFunctionsOnly(checked)} />
              <span style={{ marginLeft: 8, fontWeight: 500 }}>Charged by functions only</span>
              <Tooltip title="Charged only based on functions that was specified by the product, if lets say product has DORA, then we will only bill DORA units">
                <Icon style={{ marginLeft: 8, cursor: 'pointer' }} type="question-circle-o" />
              </Tooltip>
            </Col>
          </Row>

          <Divider />
          <Row type="flex" gutter={4}>
            <PricingTableModal
              form={form}
              selectedPricingTable={selectedPricingTable}
              productData={productData}
              onProductsChange={handleProductsChange}
              chargedByFunctionsOnly={chargedByFunctionsOnly}
            />
          </Row>

          <Row style={{ marginTop: '24px' }}>
            <Form.Item style={{ marginBottom: '0px' }}>
              {getFieldDecorator('chargeableChild', {
                initialValue: true
              })(
                <>
                  <Checkbox checked={isChecked} onChange={handleCheckboxChange}>
                    Chargeable Child Unit
                  </Checkbox>
                  <Tooltip title="If ticked, all child unit will be charged as usual. If unticked, all child unit will not be charged">
                    <Icon style={{ marginLeft: 8, cursor: 'pointer' }} type="question-circle-o" />
                  </Tooltip>
                </>
              )}
              {!isChecked && <Alert message="Child unit price will be set to 0" type="warning" showIcon style={{ marginTop: '8px' }} />}
            </Form.Item>
          </Row>
          <Divider />

          <Form.Item label="Subscription Add-On Products">
            <Radio.Group
              buttonStyle="solid"
              value={existingHostOption}
              onChange={e => setExistingHostOption(e.target.value)}
              style={{ marginBottom: '16px' }}
            >
              <Radio.Button value={true}>Existing Hosts</Radio.Button>
              <Radio.Button value={false}>New Hosts</Radio.Button>
            </Radio.Group>
            <div style={{ marginBottom: '16px' }}>
              <Checkbox
                checked={onlyBillUnifiedInboxOTAUnits}
                onChange={e => {
                  const checked = e.target.checked;
                  setOnlyBillUnifiedInboxOTAUnits(checked);
                  if (!checked) {
                    setUnifiedInboxOtaKeys([]);
                  }
                }}
              >
                Only bill unified inbox OTA units
              </Checkbox>
              <Tooltip title="When enabled, Unified Inbox is billed only for starter/standard units with active hostConnect on the selected OTAs below. For New Hosts, non-qualifying units fall back to the base (e.g. Intelligence/System) instead of the bundled add-on (e.g. Prime/Engine).">
                <Icon style={{ marginLeft: 8, cursor: 'pointer' }} type="question-circle-o" />
              </Tooltip>
            </div>
            {onlyBillUnifiedInboxOTAUnits && (
              <div style={{ marginBottom: '16px' }}>
                <span style={{ display: 'block', marginBottom: 8 }}>Unified Inbox billable OTAs</span>
                <Select
                  mode="multiple"
                  placeholder="Select OTAs"
                  value={unifiedInboxOtaKeys}
                  onChange={setUnifiedInboxOtaKeys}
                  style={{ width: '100%', maxWidth: 480 }}
                >
                  {HOST_CONNECT_OTA_OPTIONS.map(ota => (
                    <Option key={ota.code} value={ota.code}>
                      {ota.label}
                    </Option>
                  ))}
                </Select>
              </div>
            )}
            {!chargedByFunctionsOnly && (
              <SubscriptionAddOnPricingTable
                form={form}
                selectedPricingTable={selectedPricingTable}
                productData={productData}
                currentSubscriptionProducts={currentSubscriptionProducts}
                selectedSubscriptionAddOnProductsTable={selectedSubscriptionAddOnProductsTable}
              />
            )}
          </Form.Item>

          {/* Charges Section */}
          <Form.Item label="Other Products"></Form.Item>
          <Form>
            {productFields.length > 0 && (
              <Row justify="start" gutter={8}>
                <Col span={12}>Product</Col>
                <Col span={12}>Price</Col>
              </Row>
            )}
            {renderProductFields()}
            <Button type="dashed" onClick={addProduct} style={{ width: '100%' }}>
              <Icon type="plus" /> Add Products
            </Button>
          </Form>

          <Divider />
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button loading={loadingSubmit} type="primary" htmlType="submit">
                {id ? 'Update' : 'Submit'}
              </Button>
              {id && id !== defaultPricingModel && (
                <Button type="danger" onClick={handleDelete}>
                  Delete
                </Button>
              )}
            </div>
          </Form.Item>
        </Form>
      </Card>
      <Modal title="Confirm Delete" visible={deleteModalVisible} onOk={confirmDelete} onCancel={cancelDelete} okText="Confirm" cancelText="Cancel">
        <p>Are you sure you want to delete this pricing model?</p>
      </Modal>
    </>
  );
};

export default withRouter(Form.create()(PricingModelForm));
